"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryError = void 0;
var InventoryError;
(function (InventoryError) {
    InventoryError["DSKU_ALREADY_EXISTS"] = "DSKU_ALREADY_EXISTS";
    InventoryError["UNKNOWN_SKU"] = "UNKNOWN_SKU";
    InventoryError["UNKNOWN_ORDER_REF"] = "UNKNOWN_ORDER_REF";
    InventoryError["STOCKOUT"] = "STOCKOUT";
    InventoryError["INVENTORY_OUT_OF_SYNC"] = "INVENTORY_OUT_OF_SYNC";
    InventoryError["UNKNOWN_SELLER"] = "UNKNOWN_SELLER";
    InventoryError["INSUFFICIENT_INVENTORY_AVAILABLE"] = "INSUFFICIENT_INVENTORY_AVAILABLE";
    InventoryError["UNKNOWN_WAREHOUSE"] = "UNKNOWN_WAREHOUSE";
    InventoryError["BAD_REQUEST"] = "BAD_REQUEST";
    InventoryError["UNKNOWN_WAREHOUSE_TRANSFER_ASN"] = "UNKNOWN_WAREHOUSE_TRANSFER_ASN";
    InventoryError["UNKNOWN_WAREHOUSE_TRANSFER_KEY"] = "UNKNOWN_WAREHOUSE_TRANSFER_KEY";
})(InventoryError = exports.InventoryError || (exports.InventoryError = {}));
//# sourceMappingURL=InventoryError.js.map